import * as React from "react";
import {Link} from "react-router-dom";
import {ConstBreakPoint} from "src/config/styles_const/styles_const";
import Assets from "src/presentation/assets/img/assets";
import DashboardNotification from "src/presentation/common/organism/dashboard_notification";
import styled from "styled-components";
import {AppNotificationMessage} from "../../../domain/model/app_notification_message";
import {Client} from "../../../domain/model/client";
import {Company, Status as CompanyStatus,} from "../../../domain/model/company";
import {Customer, Status as CustomerStatus,} from "../../../domain/model/customer";
import {Role, User} from "../../../domain/model/user";
import MenuSpOverlay from "../../common/atom/wrapper/menu_sp_overlay";
import MenuWrapper from "../../common/atom/wrapper/menu_wrapper";
import BeforeLoginFooter from "../../common/organism/footer/before_login_footer";
import ClientFooter from "../../common/organism/footer/client_footer";
import CustomerFooter from "../../common/organism/footer/customer_footer";
import ClientMenu from "../../common/organism/menu/client_menu";
import CustomerMenu from "../../common/organism/menu/customer_menu";
import UnknownUserMenu from "../../common/organism/menu/unknown_user_menu";
import LayoutHeaderComponent from "./layout_header";
import AppNotificationWithTexts from "../../common/organism/app_notification_with_texts";

interface IProps {
    isMenuOpen: boolean;
    handleOpenMenu: (event: React.MouseEvent<HTMLElement>) => void;
    handleCloseMenu: (event: React.MouseEvent<HTMLElement>) => void;
    isMessageRoom: boolean;
    isTutorial: boolean;
    isDashboard: boolean;
    isCustomerCreate: boolean;
    user: User | null;
    company: Company | null;
    handleOnCloseNotification: (id: string) => (event: any) => void;
    notificationMessages: AppNotificationMessage[];
    children: React.ReactNode;
    handleSearchForCustomer: (values: any) => void;
    handleSearchForClient: (values: any) => void;
}

const LayoutComponent: React.FC<IProps> = (props) => {
    const {user, company, isMenuOpen, isMessageRoom, isTutorial, isDashboard} =
        props;
    const {
        handleOnCloseNotification,
        notificationMessages,
        children,
        handleSearchForCustomer,
        handleSearchForClient,
        handleOpenMenu,
        handleCloseMenu,
        isCustomerCreate,
    } = props;

    const shouldShowEditCompanyDialog =
        location.pathname !== "/client/mypage/company/_edit" &&
        location.pathname !== "/logout" &&
        location.pathname !== "/login" &&
        (user ? user.shouldUpdateCompany : false);
    const userRole: Role = user ? user.role : Role.Role_Unknown;
    const client: Client | null = user ? user.client : null;
    const customer: Customer | null = user ? user.customer : null;
    const isActive: boolean = customer
        ? customer.status === CustomerStatus.Status_Active
        : false;

    const content = () => {
        if (shouldShowEditCompanyDialog) {
            return (
                <EditCompanyDialog>
                    <DialogImgContainer>
                        <DialogImg src={Assets.login}/>
                    </DialogImgContainer>
                    <EditCompanyDialogInner>
                        <EditCompanyDialogInnerTitle>
                            {client != null ? client.name : ""}様
                        </EditCompanyDialogInnerTitle>
                        <EditCompanyDialogInnerTitle>
                            EXPERT NETWORKのご利用ありがとうございます！
                        </EditCompanyDialogInnerTitle>
                        <div
                            style={{
                                color: "white",
                                fontSize: "18px",
                                fontWeight: "bold",
                                textAlign: "center",
                                marginTop: 25,
                            }}
                        >
                            <span>当サービスのご利用には</span>
                            <span
                                style={{
                                    color: "#00D58E",
                                    fontSize: 22,
                                    display: "inline-block",
                                    marginLeft: 10,
                                    marginRight: 10,
                                }}
                            >
                企業情報のご登録
              </span>
                            <span>が必要です。</span>
                        </div>
                        <div
                            style={{
                                color: "white",
                                fontSize: "18px",
                                fontWeight: "bold",
                                textAlign: "center",
                                marginTop: 10,
                            }}
                        >
                            以下のリンクより、ご登録をお願い致します。
                        </div>
                        <EditCompanyDialogLinkBtn>
                            <Link to="/client/mypage/company/_edit">
                                企業情報の登録をする
                            </Link>
                        </EditCompanyDialogLinkBtn>
                    </EditCompanyDialogInner>
                </EditCompanyDialog>
            );
        } else {
            return (
                <Flex>
                    {isMenuOpen && <MenuSpOverlay onClick={handleCloseMenu}/>}
                    {!isMessageRoom && !isTutorial && (
                        <MenuWrapper isOpen={isMenuOpen}>
                            {userRole === Role.Role_Client && (
                                <ClientMenu
                                    client={client}
                                    company={company}
                                    messageStateList={user!.messageStateList}
                                    handleSearchForClient={handleSearchForClient}
                                    handleCloseMenu={handleCloseMenu}
                                />
                            )}
                            {userRole === Role.Role_Customer && (
                                <CustomerMenu
                                    customer={customer}
                                    messageStateList={user!.messageStateList}
                                    handleSearchForCustomer={handleSearchForCustomer}
                                    handleCloseMenu={handleCloseMenu}
                                />
                            )}
                            {userRole === Role.Role_Unknown && <UnknownUserMenu/>}
                        </MenuWrapper>
                    )}
                    <MainWrapper>
                        {children}
                        {!isMessageRoom && userRole === Role.Role_Client && (
                            <ClientFooter/>
                        )}
                        {!isMessageRoom &&
                            !isTutorial &&
                            userRole === Role.Role_Customer && <CustomerFooter/>}
                        {userRole === Role.Role_Unknown && <BeforeLoginFooter/>}
                    </MainWrapper>
                </Flex>
            );
        }
    };

    return (
        <React.Fragment>
            <LayoutHeaderComponent
                handleOpenMenu={handleOpenMenu}
                userRole={userRole}
                isMessageRoom={isMessageRoom}
                isTutorial={isTutorial}
                isCustomerCreate={isCustomerCreate}
                isDemo={
                    (company && company.status === CompanyStatus.Status_Demo) || false
                }
                client={client}
            />

            <AppNotificationWithTexts
                onClose={handleOnCloseNotification}
                appNotificationMessages={notificationMessages}
            />

            {isDashboard && !isActive && <DashboardNotification/>}

            {content()}
        </React.Fragment>
    );
};

export default LayoutComponent;

const Flex = styled.div`
    display: flex;
`;

const MainWrapper = styled.div`
    flex: 1;
`;

const EditCompanyDialog = styled.div`
    width: 100%;
    height: 100vh;
    background-color: #1d1e1f;
    position: relative;
`;

const DialogImgContainer = styled.div`
    position: absolute;
    width: 100%;
`;

export const DialogImg = styled.img`
    display: block;
    margin: 0 auto;
    padding-top: 50px;
    width: 90%;
    @media (min-width: ${ConstBreakPoint.Default}) {
        padding-top: 70px;
        width: 900px;
    }
`;

const EditCompanyDialogInner = styled.div`
    width: 100%;
    height: 100vh;
    background: rgba(29, 30, 31, 0.95);
    position: absolute;
    padding-top: 70px;
    @media (min-width: ${ConstBreakPoint.Default}) {
        padding-top: 100px;
    }
`;

const EditCompanyDialogInnerTitle = styled.div`
    width: 100%;
    color: white;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    margin-top: 50px;
    padding: 0px 10px;
    @media (min-width: ${ConstBreakPoint.Default}) {
        font-size: 40px;
    }
`;

const EditCompanyDialogLinkBtn = styled.div`
    width: 280px;
    height: 50px;
    background-color: #00d58e;
    border-radius: 3px;
    font-size: 15px;
    font-weight: bold;
    text-align: center;
    margin: 0 auto;
    margin-top: 35px;

    > a {
        color: #333;
        display: block;
        width: 100%;
        height: 50px;
        line-height: 50px;
    }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/layout/layout.tsx